import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _entities = [];

let CalendarStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _entities;
    },
    add: function(entity) {
        _entities[entity.id] = entity;
    },
    delete: function(id) {
        delete _entities[id];
    }

});

CalendarStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.CALENDAR_LIST:
            _entities = action.data;
            CalendarStore.emitChange();
            break;

        case ActionTypes.CALENDAR_LIST_ERROR:
            CalendarStore.emitChange();
            break;

        case ActionTypes.CALENDAR_INFO:
            _entities[action.data.id] = action.data;
            CalendarStore.emitChange();
            break;

        case ActionTypes.CALENDAR_INFO_ERROR:
            CalendarStore.emitChange();
            break;

        case ActionTypes.CALENDAR_SAVE:
            CalendarStore.add(action.data);
            CalendarStore.emitChange();
            break;

        case ActionTypes.CALENDAR_DELETE:
            CalendarStore.delete(action.data);
            CalendarStore.emitChange();
            break;

        default:
            break;

    }

});

export default CalendarStore;
